import { getCallingCodeForCountry, getCountryForCallingCode, getValidator } from "./phone-input-validator";

describe("phone-input validator", () => {
    it("should return correct values if an international number is passed in without country", () => {
        const validator = getValidator("+49 (0)711 234 567-89");
        expect(validator.getCountry()).toEqual("DE");
        expect(validator.getPrefix()).toEqual("+49");
        expect(validator.getFormattedValue()).toEqual("+49 711 23456789");
        expect(validator.getValidatedValue()).toEqual("+4971123456789");
        expect(validator.isValid()).toEqual(true);
    });

    it("should return correct values if a local number is passed in with country", () => {
        const validator = getValidator("(0)711 / 234 567-89", "DE");
        expect(validator.getCountry()).toEqual("DE");
        expect(validator.getPrefix()).toEqual("+49");
        expect(validator.getFormattedValue()).toEqual("+49 711 23456789");
        expect(validator.getValidatedValue()).toEqual("+4971123456789");
        expect(validator.isValid()).toEqual(true);
    });

    it("should return correct country and prefix if a country code is passed in", () => {
        const validator = getValidator("", "DE");
        expect(validator.getCountry()).toEqual("DE");
        expect(validator.getPrefix()).toEqual("+49");
        expect(validator.getFormattedValue()).toEqual("+49");
        expect(validator.getValidatedValue()).toEqual("");
        expect(validator.isValid()).toEqual(false);
    });

    it("should return empty values if invalid arguments are passed in", () => {
        const validator = getValidator("!?", "ABCDEF");
        expect(validator.getCountry()).toEqual("");
        expect(validator.getPrefix()).toEqual("");
        expect(validator.getFormattedValue()).toEqual("");
        expect(validator.getValidatedValue()).toEqual("");
        expect(validator.isValid()).toEqual(false);
    });
});

describe("getCallingCodeForCountry helper", () => {
    it("should return correct calling code for valid ISO country codes", () => {
        expect(getCallingCodeForCountry("DE")).toEqual("49");
        expect(getCallingCodeForCountry("FR")).toEqual("33");
        expect(getCallingCodeForCountry("US")).toEqual("1");
    });

    it("should return an empty string for invalid country codes", () => {
        expect(getCallingCodeForCountry("D")).toEqual("");
        expect(getCallingCodeForCountry("DEU")).toEqual("");
        expect(getCallingCodeForCountry(undefined)).toEqual("");
    });
});

describe("getCountryForPrefix helper", () => {
    it("should return correct ISO country code for valid prefixess", () => {
        expect(getCountryForCallingCode("49")).toEqual("DE");
        expect(getCountryForCallingCode("+49")).toEqual("DE");
    });

    it("should return an empty string for invalid prefixes", () => {
        expect(getCountryForCallingCode("99999")).toEqual("");
        expect(getCountryForCallingCode(undefined)).toEqual("");
    });
});
